module.exports = __webpack_public_path__ + "img/1.59a4b54e.jpg";